const { empty } = require('./booking-detail')

function invoiceTotal(value) {
  if (empty(value)) return null
  const text = String(value).trim()
  if (!/^\d+(?:\.\d{1,2})?$/.test(text)) return null
  const [whole, fraction = ''] = text.split('.')
  const integer = whole.replace(/^0+(?=\d)/, '')
  if (integer.length > 12) return null
  return `${integer}.${fraction.padEnd(2, '0')}`
}

function invoiceDraft(invoice) {
  return {
    total_amount: empty(invoice.total_amount) ? '' : String(invoice.total_amount),
    invoice_number: invoice.invoice_number || '',
    attachment: invoice.attachment ? { ...invoice.attachment } : {}
  }
}

function invoiceErrors(draft) {
  const errors = {}
  if (empty(draft.total_amount)) errors.total_amount = 'This field is required.'
  else if (invoiceTotal(draft.total_amount) === null) errors.total_amount = 'Enter an amount of 0 or more, with up to 12 digits before the decimal point and 2 after it.'
  if (String(draft.invoice_number || '').trim().length > 100) errors.invoice_number = 'Number must be 100 characters or fewer.'
  if (!draft.attachment || !draft.attachment.id) errors.attachment = 'Attach an invoice file.'
  return errors
}

function invoicePayload(draft) {
  return {
    total_amount: invoiceTotal(draft.total_amount),
    invoice_number: String(draft.invoice_number || '').trim(),
    attachment: draft.attachment.id
  }
}

module.exports = { invoiceTotal, invoiceDraft, invoiceErrors, invoicePayload }
